export const isGlobalDomain = (): boolean => {
    if (typeof window === 'undefined') return false
    const host = window.location.hostname.toLowerCase()
    return host === 'www.flyin.com' || host === 'flyin.com'
}

export default isGlobalDomain
